import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { CellRenderingService } from '../cell-rendering/cell-rendering.service';

@Component({
    selector: 'app-icon-renderer',
    template: `
        {{ value }}
        @if (displayIcon) {
          <span >
            <i class="glyphicon glyphicon-envelope"></i>
          </span>
        }
        `,
    standalone: false
})

export class IconRenderer implements INoRowsOverlayAngularComp {
   value: any;
   displayIcon: boolean;
  agInit(params): void {
    this.value = params.value;
    if (this.cellRenderingService.getIsValidDisplay(params)) {
      this.displayIcon = true;
    }
  }

  constructor( private cellRenderingService: CellRenderingService) {}
}
